import PubSub from 'underpub-js';
import slick from 'slick-carousel';
import gsap from 'gsap';
import DrawSVGPlugin from 'gsap/DrawSVGPlugin';

gsap.registerPlugin(DrawSVGPlugin);

var HeroComplex = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'comp-HeroComplex',
  };

  $.extend(true, this.options, options);
};

HeroComplex.prototype.init = function() {
  const self = this;

  self.$slides = self.options.$el.find(`.${self.data.baseClass}__slides`);
  self.$loader = self.options.$el.find(`.${self.data.baseClass}__loader`);
  self.$loaderCircle = self.options.$el.find(
    `.${self.data.baseClass}__loader__icon svg circle`,
  );
  self.$nav = self.options.$el.find(`.${self.data.baseClass}__nav`);

  PubSub.subscribe('loaded', () => self.initSlider());
};

HeroComplex.prototype.initSlider = function() {
  const self = this;
  const animationSpeed = 5;
  const animatedTextClass = 'atom-AnimatedTextReveal';
  const $slide = self.$slides.find(`.${self.data.baseClass}__slide`);
  const $slideFooter = `.${self.data.baseClass}__slide__footer`;

  const loaderTL = gsap
    .timeline({
      paused: true,
      delay: 0.5,
      repeat: -1,
    })
    .fromTo(
      self.$loader,
      {
        duration: 0.25,
        opacity: 0,
        ease: 'expo.easeout',
      },
      {
        opacity: 1,
      },
    )
    .from(self.$loaderCircle, {
      duration: animationSpeed,
      drawSVG: 0,
      ease: 'expo.easein',
    })
    .to(
      self.$loader,
      {
        duration: 0.5,
        opacity: 0,
        ease: 'expo.easeout',
      },
      '-=1',
    )
    .add(() => self.$slides.slick('slickNext'), '<');

  const animateSlideFooterIn = (parentSlide) =>
    gsap.fromTo(
      $(parentSlide).find($slideFooter),
      {
        opacity: 0,
        ease: 'expo.easein',
        duration: 0.25,
        y: 10,
      },
      {
        delay: 0.75,
        y: 0,
        opacity: 1,
      },
    );
  const animateSlideFooterOut = (parentSlide) =>
    gsap.to($(parentSlide).find($slideFooter), {
      duration: 0.5,
      opacity: 0,
      y: 10,
      ease: 'expo.easeout',
    });

  if ($slide.length <= 1) {
    loaderTL.pause(0).invalidate();
  }

  self.$slides.on('init', (event, slick) => {
    loaderTL.play(0);
    animateSlideFooterIn(self.$slides.find('.slick-current'));
  });

  self.$slides.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    const $currentSlide = $(slick.$slides.get(currentSlide));
    const $nextSlide = $(slick.$slides.get(nextSlide));

    $currentSlide.find(`.${animatedTextClass}`).trigger('animateOut');
    $nextSlide.find(`.${animatedTextClass}`).trigger('reset');
    animateSlideFooterOut($currentSlide);
  });

  self.$slides.on('afterChange', (event, slick, currentSlide, nextSlide) => {
    const $currentSlide = $(slick.$slides.get(currentSlide));

    $currentSlide.find(`.${animatedTextClass}`).trigger('animateIn');
    loaderTL.restart();
    animateSlideFooterIn($currentSlide);
  });

  self.$slides.slick({
    infinite: true,
    adaptiveHeight: true,
    autoplay: false,
    fade: true,
    speed: 500,
    arrows: false,
    swipe: true,
    pauseOnHover: false,
    dots: true,
    appendDots: self.$nav,
    dotsClass: `${self.data.baseClass}__dots`,
  });

  self.$slides
    .on('mouseenter', () => {
      loaderTL.pause();
    })
    .on('mouseleave', () => {
      loaderTL.resume();
    });
};

export default HeroComplex;
